/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ea99bacb (Fri Jun  5 23:34:18 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface GradingScaleWeight
 */
export interface GradingScaleWeight {
  /**
   * Amount of weight a gradingScaleWeight has
   * @type number
   * @memberof GradingScaleWeight
   */
  weight: number
  /**
   * Name of gradingScale weight
   * @type string
   * @memberof GradingScaleWeight
   */
  weightName: string
  /**
   * Description of the weight
   * @type string
   * @memberof GradingScaleWeight
   */
  weightDescription: string
}

export function GradingScaleWeightFromJSON(json: any): GradingScaleWeight {
  return GradingScaleWeightFromJSONTyped(json, false)
}

export function GradingScaleWeightFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GradingScaleWeight {
  if (json === undefined || json === null) {
    return json
  }
  return {
    weight: json['weight'],
    weightName: json['weightName'],
    weightDescription: json['weightDescription'],
  }
}

export function GradingScaleWeightToJSON(
  value?: GradingScaleWeight | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    weight: value.weight,
    weightName: value.weightName,
    weightDescription: value.weightDescription,
  }
}
